import React from 'react';
import Modal from './Modal';
import './Add.css';
import AddItemForm from './AddItemForm';
import AddAppointmentForm from './AddAppointmentForm';
import { useFileContext } from '../../../Context/FileContext';
import Edit from '../Edit/Edit';

const Add = () => {
    const { showModal, setShowModal, formType, setFormType } = useFileContext()

    const handleOpenModal = (type) => {
        setFormType(type);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setFormType('');
    };

    return (
        <div>
            <button className="add-button" onClick={() => handleOpenModal('addItem')}>Add Item</button>
            <button className="add-button" onClick={() => handleOpenModal('addAppointment')}>Add Appointment</button>

            <Modal show={showModal} onClose={handleCloseModal}>
                {formType === 'addItem' && <AddItemForm />}
                {formType === 'addAppointment' && <AddAppointmentForm />}
                {formType === 'edit' && <Edit />}
            </Modal>
        </div>
    );
};

export default Add;
